import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TK2UserLookupDM from './TK2UserLookupDM'
import TTextDM from './TTextDM'

/**
 * Historie položek věrnostního programu
 */
export default class TLoyaltyProgramItemHistoryDM extends Data {
	public static className = 'TLoyaltyProgramItemHistoryDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Odběratel
	 */
	CollectorId?: number

	/**
	 * Skupina
	 */
	GroupId?: number

	/**
	 * Počet bodů
	 */
	PointsCount?: number

	/**
	 * Položka věrnostního programu
	 */
	LoyaltyProgramItemId?: number

	/**
	 * Vytvořeno
	 */
	CreatedOn?: Date

	/**
	 * Věrnostní program
	 */
	LoyaltyProgramId?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * undefined
	 */
	CollectorNameCalc?: string

	/**
	 * Vytvořil
	 */
	@Type(() => TK2UserLookupDM)
	CreatedById?: TK2UserLookupDM

	/**
	 * Typ změny
	 */
	@Type(() => TTextDM)
	ChangeType?: TTextDM
}